import { CaseRecord } from "../models/Case"

function countCase(status: string, assignedTo: string, caseType: string, alerts: any[],counts: any) {
    let key: string = status + "_" + assignedTo + "_" + caseType
    counts.Breakdown[key]         = counts.Breakdown[key] ? counts.Breakdown[key] + 1 : 1
    counts.Status[status]         = counts.Status[status] ? counts.Status[status] + 1 : 1
    counts.AssignedTo[assignedTo] = counts.AssignedTo[assignedTo] ? counts.AssignedTo[assignedTo] + 1 : 1
    counts.CaseType[caseType]     = counts.CaseType[caseType] ? counts.CaseType[caseType] + 1 : 1
    for (const alert of alerts) {
        const alertName = alert?.name?.split(":")[0] ?? "Unknown"
        if (!counts.Alert[alertName]) {counts.Alert[alertName] = { total: 0, warn: 0, info: 0 }}
        const a = counts.Alert[alertName]
        a.total++
        if (alert?.alert === 'warn') {a.warn++} else {a.info++}
    }
    counts.Total++
}

export function CalcSiteOverview(cases: CaseRecord[], css: any) {
  let counts = {CaseType: {}, AssignedTo: {}, Status: {}, Alert: {}, Breakdown: {}, Total: 0}

  for (const c of cases) {
    let caseType = (c?.Details?.FactsOfLoss?.CaseType) ?? "Unknown"

    const cs = css?.find((cs: any) => cs.CaseId === c._id)
    const alerts = (cs?.ActivityAlerts ?? []).flatMap((aa: any) => !aa?.alert ? [] : [{ name: aa?.name.split(":")[0], alert: aa?.alert }]) 

    countCase(c?.Status, c?.AssignedTo, caseType, alerts, counts)
  }

  return {Name: "CaseBreakdown", Values: counts}
}
